import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [

    {
      path: '/test',
      name: 'test',
      meta: {
        requiresAuth: true
      },
      component: () =>
        import('@/views/test/test.vue')
    },

    {
      path: '/',
      name: 'App',
      meta: {
        requiresAuth: true
      },
      component: () =>
          import('@/views/company/company.vue')
    },

    {
      path: '/login',
      name: 'login',
      meta: {
        requiresAuth: false
      },
      component: () =>
        import('@/views/Login.vue')
    },
    {
      path: '/index',
      name: 'index',
      meta: {
        requiresAuth: true
      },
      component: () =>
        import('@/views/index/Index.vue')
    },
    {
      path: '/platformuser/user/list',
      name: 'PlatformuserUserList',
      meta: {
        requiresAuth: true
      },
      component: () =>
        import('@/views/platformuser/User.vue')
    },

    {
      path: '/platformuser/role/list',
      name: 'PlatformuserRoleList',
      meta: {
        requiresAuth: true
      },
      component: () =>
        import('@/views/platformuser/role/roleList.vue')
    },
    {
      path: '/platformuser/role/add',
      name: 'PlatformuserRoleAdd',
      meta: {
        requiresAuth: true
      },
      component: () =>
        import('@/views/platformuser/role/addRole.vue')
    },

    {
      path: '/platformuser/power/list',
      name: 'PlatformuserUserPowerList',
      meta: {
        requiresAuth: true
      },
      component: () =>
        import('@/views/platformuser/PowerList.vue')
    },

    {
      path: '/company/list',
      name: 'companyList',
      meta: {
        requiresAuth: true
      },
      component: () =>
        import('@/views/company/company.vue')
    },
    {
      path: '/company/employee/list',
      name: 'companyEmployeeList',
      meta: {
        requiresAuth: true
      },
      component: () =>
        import('@/views/company/company-employee.vue')
    },
    // 政务文件管理
    {
      path: '/knowledge/government',
      name: 'Knowledge',
      meta: {
        requiresAuth: true
      },
      component: () =>
        import('@/views/knowledge/government.vue')
    },
  ]
})
